import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import {
  PORTAL_ADMIN,
  MANAGER,
  PROJECT_ADMIN,
  PROJECT_SPONSOR,
  TEAM_LEADER,
  EMPLOYEE,
} from "../../store/actions/users/usersActions";
import { toMonetaryFormat, formatDate } from "../../common/Utilities";
import { Cache } from "aws-amplify";

class ProjectDetails extends Component {
  constructor(props) {
    super(props);
    this.roleId = Cache.getItem("roleId");
  }

  displayManageTasksButton = (projectId) => {
    if (
      this.roleId !== MANAGER ||
      this.roleId !== PORTAL_ADMIN ||
      this.roleId !== PROJECT_ADMIN ||
      this.roleId !== TEAM_LEADER
    ) {
      return "";
    }

    return (
      <div className="float-right">
        <Button
          size="sm"
          onClick={() => {
            this.props.history.push("/projects/tasks?id=" + projectId);
          }}
        >
          Manage Tasks
        </Button>
      </div>
    );
  };

  render() {
    let id = "";
    let projectCode = "";
    let startDate = "";
    let endDate = "";
    let clientName = "";
    let projectManagerName = "";
    let projectSponsorName = "";
    let projectRevenue = "";
    let budgetedHours = "";
    let mandays = "";
    let department = "";
    let remarks = "";
    let fullyLoaded = "";
    let parentProject = "";
    let projectAttachments = [];

    if (!this.props.forApproval) {
      const project = this.props.project;

      if (Object.keys(project).length > 0) {
        id = project.id;
        projectCode = project.project_code;
        startDate = project.start_date;
        endDate = project.end_date;
        projectRevenue = project.project_revenue;
        budgetedHours = project.budgeted_hours;
        mandays = project.mandays;
        projectAttachments = project.project_attachments;
        fullyLoaded = project.fully_loaded
          ? "Fully Loaded Cost"
          : "Unloaded Cost";

        if (typeof project.client !== "undefined") {
          const client = project.client;
          clientName = client.client_name;
        }

        if (typeof project.project_manager !== "undefined") {
          let projectManager = project.project_manager;
          //FOR ENHANCEMENT - project_manager property can be the userId or object of PM details. For some reason,
          //there's an error when project_manager is an object during approval, so I made a new property
          //project_manager_details to avoid the error - mkesguerra 12/22/2020
          if (typeof projectManager === "object") {
            if (projectManager) {
              projectManagerName =
                projectManager.first_name + " " + projectManager.last_name;
            }
          } else {
            if (typeof project.project_manager_details !== "undefined") {
              projectManager = project.project_manager_details;
              if (projectManager) {
                projectManagerName =
                  projectManager.first_name + " " + projectManager.last_name;
              }
            }
          }
        }

        if (typeof project.parent_project !== "undefined") {
          let objParentProject = project.parent_project;

          if (typeof objParentProject.id !== "undefined") {
            parentProject = objParentProject.project_name;
          }
        }

        if (typeof project.project_sponsor !== "undefined") {
          const projectSponsor = project.project_sponsor;
          if (projectSponsor) {
            projectSponsorName =
              projectSponsor.first_name + " " + projectSponsor.last_name;
          }
        }

        if (typeof project.department_id !== "undefined") {
          department = project.department_id;
          if (department) {
            department = department.department_name;
          }
        }

        if (typeof project.parent_project !== "undefined") {
          parentProject = project.parent_project;
          if (parentProject) {
            parentProject = parentProject.project_name;
          } else {
            parentProject = "(none)";
          }
        }

        const approvers = project.project_approvers;

        remarks = approvers
          .filter((data) => (data.remarks ? data : null))
          .map((approver) => {
            return <div>{approver.remarks}</div>;
          });
      }
    } else {
      const newDetails = this.props.newDetails;
      const oldDetails = this.props.oldDetails;

      if (Object.keys(newDetails).length && Object.keys(oldDetails).length) {
        if (oldDetails.project_code !== newDetails.project_code) {
          projectCode = {
            old: oldDetails.project_code,
            new: newDetails.project_code,
          };
        } else {
          projectCode = oldDetails.project_code;
        }

        if (
          formatDate(new Date(oldDetails.start_date)) !==
          formatDate(new Date(newDetails.start_date))
        ) {
          startDate = {
            old: oldDetails.start_date,
            new: newDetails.start_date,
          };
        } else {
          startDate = oldDetails.start_date;
        }

        if (
          formatDate(new Date(oldDetails.end_date)) !==
          formatDate(new Date(newDetails.end_date))
        ) {
          endDate = {
            old: oldDetails.end_date,
            new: newDetails.end_date,
          };
        } else {
          endDate = oldDetails.end_date;
        }

        const oldRevenue = oldDetails.project_revenue
          ? parseFloat(oldDetails.project_revenue)
          : "0.00";
        const newRevenue = newDetails.project_revenue
          ? parseFloat(newDetails.project_revenue)
          : "0.00";

        if (oldRevenue !== newRevenue) {
          projectRevenue = {
            old: oldRevenue,
            new: newRevenue,
          };
        } else {
          projectRevenue = oldDetails.project_revenue;
        }

        const oldBudgetedHours = oldDetails.budgeted_hours
          ? parseFloat(oldDetails.budgeted_hours)
          : "0";
        const newBudgetedHours = newDetails.budgeted_hours
          ? parseFloat(newDetails.budgeted_hours)
          : "0";

        if (oldBudgetedHours !== newBudgetedHours) {
          budgetedHours = {
            old: oldDetails.budgeted_hours,
            new: newDetails.budgeted_hours,
          };
        } else {
          budgetedHours = oldDetails.budgeted_hours;
        }

        const oldMandays = oldDetails.mandays
          ? parseFloat(oldDetails.mandays)
          : "0";
        const newMandays = newDetails.mandays
          ? parseFloat(newDetails.mandays)
          : "0";

        if (oldMandays !== newMandays) {
          mandays = {
            old: oldDetails.mandays,
            new: newDetails.mandays,
          };
        } else {
          mandays = oldDetails.mandays;
        }

        if (
          typeof oldDetails.client !== "undefined" &&
          typeof newDetails.client
        ) {
          let oldClientId = 0;
          let oldClientName = "";
          let newClientId = 0;
          let newClientName = "";

          const oldClient = oldDetails.client;
          const newClient = newDetails.client;

          if (oldClient && typeof oldClient.id !== "undefined") {
            oldClientId = oldClient.id;
            oldClientName = oldClient.client_name;
          }

          if (newClient && typeof newClient.id !== "undefined") {
            newClientId = newClient.id;
            newClientName = newClient.client_name;
          }

          if (oldClientId !== newClientId) {
            clientName = {
              old: oldClientName,
              new: newClientName,
            };
          } else {
            clientName = oldClientName;
          }
        }

        if (
          typeof oldDetails.project_manager !== "undefined" &&
          typeof newDetails.project_manager !== "undefined"
        ) {
          let oldPMName = "";
          let oldPMId = 0;
          let newPMName = "";
          let newPMId = 0;

          let oldProjectManager = oldDetails.project_manager;
          let newProjectManager = newDetails.project_manager;

          if (
            typeof oldProjectManager !== "undefined" &&
            typeof newProjectManager !== "undefined"
          ) {
            if (oldProjectManager && typeof oldProjectManager === "object") {
              oldPMName =
                oldProjectManager.first_name +
                " " +
                oldProjectManager.last_name;
              oldPMId = oldProjectManager.id;
            }

            if (newProjectManager && typeof newProjectManager === "object") {
              newPMName =
                newProjectManager.first_name +
                " " +
                newProjectManager.last_name;
              newPMId = newProjectManager.id;
            }

            if (oldPMId !== newPMId) {
              projectManagerName = {
                old: oldPMName,
                new: newPMName,
              };
            } else {
              projectManagerName = oldPMName;
            }
          }
        }

        if (
          typeof oldDetails.project_sponsor !== "undefined" &&
          typeof newDetails.project_sponsor !== "undefined"
        ) {
          let oldPSName = "";
          let oldPSId = 0;
          let newPSName = "";
          let newPSId = 0;

          let oldProjectSponsor = oldDetails.project_sponsor;
          let newProjectSponsor = newDetails.project_sponsor;

          if (
            typeof oldProjectSponsor !== "undefined" &&
            typeof newProjectSponsor !== "undefined"
          ) {
            if (oldProjectSponsor && typeof oldProjectSponsor === "object") {
              oldPSId = oldProjectSponsor.id;
              oldPSName =
                oldProjectSponsor.first_name +
                " " +
                oldProjectSponsor.last_name;
            }

            if (newProjectSponsor && typeof newProjectSponsor === "object") {
              newPSId = newProjectSponsor.id;
              newPSName =
                newProjectSponsor.first_name +
                " " +
                newProjectSponsor.last_name;
            }

            if (oldPSId !== newPSId) {
              projectSponsorName = {
                old: oldPSName,
                new: newPSName,
              };
            } else {
              projectSponsorName = oldPSName;
            }
          }
        }

        if (
          typeof oldDetails.department_id !== "undefined" &&
          typeof newDetails.department_id !== "undefined"
        ) {
          let oldDepartment = oldDetails.department_id;
          let newDepartment = newDetails.department_id;

          if (
            typeof oldDepartment !== "undefined" &&
            typeof newDepartment !== "undefined"
          ) {
            if (oldDepartment.id !== newDepartment.id) {
              department = {
                old: oldDepartment.department_name,
                new: newDepartment.department_name,
              };
            } else {
              department = oldDepartment.department_name;
            }
          }
        }

        if (
          typeof oldDetails.fully_loaded !== "undefined" &&
          typeof newDetails.fully_loaded !== "undefined"
        ) {
          let oldCostingType = oldDetails.fully_loaded;
          let newCostingType = newDetails.fully_loaded;

          if (oldCostingType !== newCostingType) {
            fullyLoaded = {
              old: oldCostingType ? "Fully Loaded" : "Unloaded",
              new: newCostingType ? "Fully Loaded" : "Unloaded",
            };
          } else {
            fullyLoaded = oldDetails.fully_loaded ? "Fully Loaded" : "Unloaded";
          }
        }

        if (
          typeof oldDetails.parent_project !== "undefined" &&
          typeof newDetails.parent_project !== "undefined"
        ) {
          let oldParentProject = oldDetails.parent_project;
          let newParentProject = newDetails.parent_project;

          if (!oldParentProject) {
            oldParentProject = {};
            oldParentProject.id = 0;
            oldParentProject.project_name = "(none)";
          }

          if (!newParentProject) {
            newParentProject = {};
            newParentProject.id = 0;
            newParentProject.project_name = "(none)";
          }

          if (
            typeof oldParentProject.id !== "undefined" &&
            typeof newParentProject.id !== "undefined"
          ) {
            if (oldParentProject.id !== newParentProject.id) {
              parentProject = {
                old: oldParentProject.project_name,
                new: newParentProject.project_name,
              };
            } else {
              parentProject = oldParentProject.project_name;
            }
          }
        }

        if (
          typeof oldDetails.project_platform !== "undefined" &&
          typeof newDetails.project_platform !== "undefined"
        ) {
          let oldGroups = oldDetails.project_platform;
          let newGroups = newDetails.project_platform;
          let oldGroupIds = [];
          let oldGroupNames = [];
          let newGroupIds = [];
          let newGroupNames = [];

          if (
            typeof oldGroups !== "undefined" &&
            typeof newGroups !== "undefined"
          ) {
            oldGroups.forEach((group) => {
              oldGroupIds.push(group.id);
              oldGroupNames.push(group.platform_name);
            });

            newGroups.forEach((group) => {
              newGroupIds.push(group.id);
              newGroupNames.push(group.platform_name);
            });
          }

          //compare the two arrays
          /*
          let isNotEqual = false;
          if (oldGroupIds.length === newGroupIds.length) {
            oldGroupIds.forEach(groupId => {
              if (!newGroupIds.includes(groupId)) {
                isNotEqual = true;
              }
            })
          }
          else {
            isNotEqual = true;
          }
          */
        }

        if (
          typeof oldDetails.project_attachments !== "undefined" &&
          typeof newDetails.project_attachments !== "undefined"
        ) {
          let oldAttachments = oldDetails.project_attachments;
          let newAttachments = newDetails.project_attachments;

          if (oldAttachments.length || newAttachments.length) {
            if (oldAttachments.length !== newAttachments.length) {
              projectAttachments = {
                old: oldAttachments,
                new: newAttachments,
              };
            } else {
              let hasChanges = false;
              oldAttachments.forEach((oldAttachment, i) => {
                if (
                  oldAttachment.attachment_name !==
                  newAttachments[i].attachment_name
                ) {
                  hasChanges = true;
                }

                if (
                  oldAttachment.attachment_link !==
                  newAttachments[i].attachment_link
                ) {
                  hasChanges = true;
                }
              });

              if (hasChanges) {
                projectAttachments = {
                  old: oldAttachments,
                  new: newAttachments,
                };
              } else {
                projectAttachments = oldAttachments;
              }
            }
          }
        }
      }
    }
    return (
      <React.Fragment>
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Project Details</h6>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            {this.displayManageTasksButton(id)}
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row className="mt-3">
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Project Code</b>
                </div>
                {typeof projectCode === "object" ? (
                  <>
                    <div className={projectCode.old ? "old-value" : "none"}>
                      {projectCode.old ? projectCode.old : "(none)"}
                    </div>
                    <div className="new-value">{projectCode.new}</div>
                  </>
                ) : (
                  <div>{projectCode}</div>
                )}
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Client</b>
                </div>
                {typeof clientName === "object" ? (
                  <>
                    <div className={clientName.old ? "old-value" : "none"}>
                      {clientName.old ? clientName.old : "(none)"}
                    </div>
                    <div className="new-value">{clientName.new}</div>
                  </>
                ) : (
                  <div>{clientName}</div>
                )}
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>MS Manager</b>
                </div>
                {typeof projectManagerName === "object" ? (
                  <>
                    <div
                      className={projectManagerName.old ? "old-value" : "none"}
                    >
                      {projectManagerName.old
                        ? projectManagerName.old
                        : "(none)"}
                    </div>
                    <div className="new-value">{projectManagerName.new}</div>
                  </>
                ) : (
                  <div>{projectManagerName}</div>
                )}
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Mandays</b>
                </div>
                {typeof mandays === "object" ? (
                  <>
                    <div className={mandays.old ? "old-value" : ""}>
                      {mandays.old && mandays.old > 0
                        ? mandays.old.toFixed(2)
                        : 0.0}
                    </div>
                    <div className="new-value">
                      {mandays.new && mandays.new > 0
                        ? mandays.new.toFixed(2)
                        : 0.0}
                    </div>
                  </>
                ) : (
                  <div>{mandays && mandays > 0 ? mandays.toFixed(2) : 0.0}</div>
                )}
              </Col>
            </Row>
            <Row className="mt-5">
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Project Start Date</b>
                </div>
                {typeof startDate === "object" ? (
                  <>
                    <div className={startDate ? "old-value" : "none"}>
                      {startDate.old
                        ? formatDate(new Date(startDate.old), "-")
                        : "(none)"}
                    </div>
                    <div className="new-value">
                      {formatDate(new Date(startDate.new), "-")}
                    </div>
                  </>
                ) : (
                  <div>{startDate}</div>
                )}
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Project End Date</b>
                </div>
                {typeof endDate === "object" ? (
                  <>
                    <div className={endDate ? "old-value" : "none"}>
                      {endDate.old
                        ? formatDate(new Date(endDate.old), "-")
                        : "(none)"}
                    </div>
                    <div className="new-value">
                      {formatDate(new Date(endDate.new), "-")}
                    </div>
                  </>
                ) : (
                  <div>{endDate}</div>
                )}
              </Col>
              {this.roleId !== EMPLOYEE ? (
                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <div>
                    <b>Project Revenue</b>
                  </div>
                  {typeof projectRevenue === "object" ? (
                    <>
                      <div className="old-value">
                        ₱
                        {projectRevenue.old && projectRevenue.old > 0
                          ? toMonetaryFormat(projectRevenue.old)
                          : "0.00"}
                      </div>
                      <div className="new-value">
                        ₱
                        {projectRevenue.new && projectRevenue.new > 0
                          ? toMonetaryFormat(projectRevenue.new)
                          : "0.00"}
                      </div>
                    </>
                  ) : (
                    <div>
                      ₱
                      {projectRevenue && projectRevenue > 0
                        ? toMonetaryFormat(projectRevenue)
                        : "0.00"}
                    </div>
                  )}
                </Col>
              ) : (
                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <div>
                    <b>Parent Project</b>
                  </div>
                  {typeof parentProject === "object" ? (
                    <>
                      <div className={parentProject.old ? "old-value" : "none"}>
                        {parentProject.old ? parentProject.old : "(none)"}
                      </div>
                      <div className="new-value">{parentProject.new}</div>
                    </>
                  ) : (
                    <div>{parentProject}</div>
                  )}
                </Col>
              )}

              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Budgeted Hours</b>
                </div>
                {typeof budgetedHours === "object" ? (
                  <>
                    <div className="old-value">
                      {budgetedHours.old && budgetedHours.old > 0
                        ? budgetedHours.old.toFixed(2)
                        : 0.0}
                    </div>
                    <div className="new-value">
                      {budgetedHours && budgetedHours > 0
                        ? budgetedHours.old.toFixed(2)
                        : 0.0}
                    </div>
                  </>
                ) : (
                  <div>
                    {budgetedHours && budgetedHours > 0
                      ? budgetedHours.toFixed(2)
                      : 0.0}
                  </div>
                )}
                <div></div>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Department</b>
                </div>
                {typeof department === "object" ? (
                  <>
                    <div className={department.old ? "old-value" : "none"}>
                      {department.old ? department.old : "(none)"}
                    </div>
                    <div className="new-value">{department.new}</div>
                  </>
                ) : (
                  <div>{department}</div>
                )}
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <div>
                  <b>Costing Type</b>
                </div>
                {typeof fullyLoaded === "object" ? (
                  <>
                    <div className={fullyLoaded.old ? "old-value" : "none"}>
                      {fullyLoaded.old ? fullyLoaded.old : "(none)"}
                    </div>
                    <div className="new-value">{fullyLoaded.new}</div>
                  </>
                ) : (
                  <div>{fullyLoaded}</div>
                )}
              </Col>
              {this.roleId !== EMPLOYEE && (
                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <div>
                    <b>Parent Project</b>
                  </div>
                  {typeof parentProject === "object" ? (
                    <>
                      <div className={parentProject.old ? "old-value" : "none"}>
                        {parentProject.old ? parentProject.old : "(none)"}
                      </div>
                      <div className="new-value">{parentProject.new}</div>
                    </>
                  ) : (
                    <div>{parentProject}</div>
                  )}
                </Col>
              )}
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                {/* <div>
                  <b>Project Sponsor</b>
                </div>
                {typeof projectSponsorName === "object" ? (
                  <>
                    <div
                      className={projectSponsorName.old ? "old-value" : "none"}
                    >
                      {projectSponsorName.old
                        ? projectSponsorName.old
                        : "(none)"}
                    </div>
                    <div className="new-value">{projectSponsorName.new}</div>
                  </>
                ) : (
                  <div>{[projectSponsorName]}</div>
                )} */}
              </Col>
            </Row>
            {remarks.length > 0 && (
              <Row className="mt-5">
                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <div>
                    <b>Remarks</b>
                  </div>
                  <div>{remarks}</div>
                </Col>
              </Row>
            )}
            {projectAttachments.length ||
            Object.keys(projectAttachments).length ? (
              <>
                <Row className="mt-5">
                  <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                    <b>Attachments</b>
                  </Col>
                </Row>
                {Array.isArray(projectAttachments) ? (
                  <Row>
                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                      {projectAttachments.length &&
                        projectAttachments.map((projectAttachment, key) => {
                          return (
                            <Row key={key}>
                              <Col>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={projectAttachment.attachment_link}
                                >
                                  {projectAttachment.attachment_name}
                                </a>
                              </Col>
                            </Row>
                          );
                        })}
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row>
                      <Col
                        xs={3}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        className="old-value"
                      >
                        {projectAttachments.old.length &&
                          projectAttachments.old.map((projectAttachment) => {
                            return (
                              <Row>
                                <Col>
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={projectAttachment.attachment_link}
                                  >
                                    {projectAttachment.attachment_name}
                                  </a>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={3}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        className="new-value"
                      >
                        {projectAttachments.new.length &&
                          projectAttachments.new.map((projectAttachment) => {
                            return (
                              <Row>
                                <Col>
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={projectAttachment.attachment_link}
                                  >
                                    {projectAttachment.attachment_name}
                                  </a>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default ProjectDetails;
